import type { MatchingPatient } from '@/types/patient-api';

/**
 * Drop the patient's own record from a duplicate-match result set.
 *
 * Flutter `create_patient_screen.dart:389` removes matches whose
 * `idNumber == initialIdNumber` so an existing patient never flags as its
 * own duplicate. We exclude by `patientId` instead (more robust — it also
 * holds if the user changes the ID but the server still echoes the current
 * record).
 *
 * - **Create mode** (`currentPatientId` null/empty): nothing is excluded, so
 *   real duplicates against existing patients still surface and block Save.
 * - **Edit mode**: the current patient is removed, so editing a patient whose
 *   ID is already in the DB no longer self-flags.
 */
export function excludeOwnMatch(
  matches: MatchingPatient[],
  currentPatientId: string | null | undefined,
): MatchingPatient[] {
  if (!currentPatientId) return matches;
  return matches.filter((m) => m.patientId !== currentPatientId);
}
